// IdleTimeoutWrapper.js
import useIdleTimeout from '../hooks/useIdleTimeout';

const IdleTimeoutWrapper = ({ timeout, children }) => {
    useIdleTimeout(timeout);
    return <>{children}</>;
};

export default IdleTimeoutWrapper;
